import settings from "./settings"
import logistic from "./logistic";

const reducers =  {
  settings,
  logistic
};

export default reducers;
